import axiosClient from "./axiosClient";
import { ApiResponse } from "models";
import { InvoiceListPayload } from "models/inVoice";

export interface UpdateInvoicePayload {
  invoiceNumber: any;
  dateOfIssue: string;
  region: string;
  billTo: string;
  dueDate: string;
  brandDetails: any[];
  discount?: number;
  bank_receipt_no?: string;
  subscriptionId?: string;
  supplyEndDate?: string;
  supplyStartDate?: string;
  customerId?: string;
  customAmount?: number;
  invoiceAmount?: number;
  brandId?: string;
}

const invoiceApi = {
  getInvoiceList(data: InvoiceListPayload): Promise<any> {
    const params: Record<string, string> = {};

    if (data.page) params.page = String(data.page);
    if (data.limit) params.limit = String(data.limit);
    if (data.search) params.search = data.search;
    if (data.sortName) params.sortField = data.sortName;
    if (data.sortType) params.sortType = data.sortType;
    if (data.customerId) params.customerId = String(data.customerId);

    const queryString = new URLSearchParams(params).toString();

    const url = `/invoice/getInvoice${queryString ? `?${queryString}` : ""}`;

    return axiosClient.get(url);
  },

  voidInvoice(invoiceId: string, voidReason: string): Promise<ApiResponse> {
    const url = `/invoice/voidInvoice?invoiceId=${invoiceId}&voidReason=${voidReason}`;
    return axiosClient.put<ApiResponse>(url);
  },

  deleteInvoice(invoiceId: string): Promise<ApiResponse> {
    const url = `/invoice/deleteInvoice?invoiceId=${invoiceId}`;
    return axiosClient.delete<ApiResponse>(url);
  },
  updateInvoice(data: any): Promise<ApiResponse> {
    const url = `/invoice/createInvoice`;

    return axiosClient.post<ApiResponse>(url, data);
  },
  getInvoicePdf(invoiceId: string): Promise<ApiResponse> {
    const url = `/invoice/getInvoicePdf?invoiceId=${invoiceId}`;
    return axiosClient.get<ApiResponse>(url);
  },
  sendInvoice(data: any): Promise<ApiResponse> {
    const url = `/invoice/sendInvoice`;
    return axiosClient.post(url, data);
  },
  getPendingInvoices(data: any): Promise<any> {
    const baseUrl = `/invoice/getPendingInvoices`;

    const params = new URLSearchParams();

    if (data.page) params.append("page", data.page);
    if (data.limit) params.append("limit", data.limit);
    if (data.search) params.append("search", data.search);
    if (data.currency) params.append("currency", data.currency);
    if (data.sortName) params.append("sortField", data.sortName);
    if (data.sortType) params.append("sortType", data.sortType);

    const url = `${baseUrl}?${params.toString()}`;

    return axiosClient.get(url);
  },
  editInvoice(invoiceId: string, data: any): Promise<ApiResponse> {
    const url = `/invoice/updateInvoice?invoiceId=${invoiceId}`;

    return axiosClient.put<ApiResponse>(url, data);
  },
};

export default invoiceApi;
